export class AccountSearch  {
  clientName: string;
  phoneNumber: string;
  clientNumber: string;
  heatmaptypeid = 0;
  parentsOnly: boolean;
  studentOnly: boolean;
  page = 1;
  pageSize = 10;
  emailAddress: string;
  firstName: string;
  lastName: string;
  partnerIds = [];
}
